import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setAllRecipes, setRecipesLoading, setSelectedRecipePage, updateSelectedRecipeData } from "../../Store/slices/recipeSlice";
import ListRecipes from "../../Pages/Recipes/components/ListRecipes";
import AddNewRecipe from "../../Pages/Recipes/components/AddNewRecipe";
import { useState } from "react";
import toast from "react-hot-toast";
import { storage } from "../../firebaseConfig";
import { ref, uploadBytesResumable, getDownloadURL, uploadBytes } from 'firebase/storage';
import DeleteRecipe from "../../Pages/Recipes/components/DeleteRecipe";
import UpdateRecipesPage from "../../Pages/Recipes/components/UpdateRecipesPage";
import { RootState } from "../../Store/store";

export const useRecipesHook = () => {

    const BASE_URL = 'https://api.eatwellmama.com'

    const ENDPOINTS = {
        LIST_ALL_RECIPES: BASE_URL + '/api/recipes/getAllRecipesForAdmin',
        SEARCH_RECIPES: BASE_URL + '/api/recipes/searchRecipesForAdmin',
        FILTER_RECIPES: BASE_URL + '/api/recipes/getRecipeByFilters',
    }

    const {
        selectedRecipePage,
        allRecipes,
        recipesLoading,
        selectedRecipeData,
    } = useSelector((state: RootState) => state.recipe.value);

    const {
        accessToken,
    } = useSelector((state: RootState) => state.auth.value);

    const dispatch = useDispatch();

    const changeSelectedRecipePage = (page: number) => {
        dispatch(setSelectedRecipePage(page));
    };


    const recipeTypes = [
        {
            id: 1,
            title: 'Breakfast',
            value: 'Breakfast'
        },
        {
            id: 2,
            title: 'Lunch',
            value: 'Lunch'
        },
        {
            id: 3,
            title: 'Dinner',
            value: 'Dinner'
        },
        {
            id: 4,
            title: 'Snacks',
            value: 'Snacks'
        },
        {
            id: 5,
            title: 'Drink',
            value: 'Drink'
        },
        {
            id: 6,
            title: 'All',
            value: 'All'
        },
    ];

    const recipeTrimesters = [
        {
            id: 1,
            title: 'Trimester - 1',
            value: '1'
        },
        {
            id: 2,
            title: 'Trimester - 2',
            value: '2'
        },
        {
            id: 3,
            title: 'Trimester - 3',
            value: '3'
        },
        {
            id: 4,
            title: 'All',
            value: 'All'
        }
    ];

    const selectableRecipeTags = [
        {
            id: 1,
            title: 'Vegan',
            value: 'Vegan'
        },
        {
            id: 2,
            title: 'Vegetarian',
            value: 'Vegetarian'
        },
        {
            id: 3,
            title: 'Non-Vegetarian',
            value: 'Non-Vegetarian',
        },
        {
            id: 4,
            title: 'Protein Rich',
            value: 'Protein Rich',
        },
        {
            id: 5,
            title: 'Low Carb',
            value: 'Low Carb',
        },
        {
            id: 6,
            title: 'High Carb',
            value: 'High Carb',
        },
        {
            id: 7,
            title: 'Keto',
            value: 'Keto',
        },
        {
            id: 8,
            title: 'Gluten Free',
            value: 'Gluten Free',
        }
    ];

    //Recipe States:
    const [recipeName, setRecipeName] = useState('');
    const [recipeType, setRecipeType] = useState('');
    const [recipeTrimester, setRecipeTrimester] = useState('');
    const [recipePreparationTime, setRecipePreparationTime] = useState(0);
    const [recipeCookTime, setRecipeCookTime] = useState(0);
    const [recipeServes, setRecipeServes] = useState(0);
    const [recipeTags, setRecipeTags] = useState([]);
    const [recipeMethod, setRecipeMethod] = useState('');
    const [recipeIngredients, setRecipeIngredients] = useState<any>([]);
    const [recipeImage, setRecipeImage] = useState('');
    const [recipeCarbs, setRecipeCarbs] = useState(0);
    const [recipeProtein, setRecipeProtein] = useState(0);
    const [recipeFats, setRecipeFats] = useState(0);
    const [recipeCalories, setRecipeCalories] = useState(0);
    const [recipeCalcium, setRecipeCalcium] = useState(0);
    const [blogReferences, setBlogReferences] = useState([]);
    const [isPremium, setIsPremium] = useState(false);

    //Vitamins:
    const [recipeVitaminA, setRecipeVitaminA] = useState(0);
    const [recipeVitaminAUnit, setRecipeVitaminAUnit] = useState('mg');
    const [recipeVitaminB6, setRecipeVitaminB6] = useState(0);
    const [recipeVitaminB12, setRecipeVitaminB12] = useState(0);
    const [recipeVitaminB6Unit, setRecipeVitaminB6Unit] = useState('mg');
    const [recipeVitaminB12Unit, setRecipeVitaminB12Unit] = useState('mg');
    const [recipeVitaminC, setRecipeVitaminC] = useState(0);
    const [recipeVitaminCUnit, setRecipeVitaminCUnit] = useState('mg');
    const [recipeVitaminD, setRecipeVitaminD] = useState(0);
    const [recipeVitaminDUnit, setRecipeVitaminDUnit] = useState('mg');
    const [recipeVitaminE, setRecipeVitaminE] = useState(0);
    const [recipeVitaminEUnit, setRecipeVitaminEUnit] = useState('mg');
    const [recipeVitaminK, setRecipeVitaminK] = useState(0);
    const [recipeVitaminKUnit, setRecipeVitaminKUnit] = useState('mg');

    /*
    recipeCholesterol,
        recipeCholesterolUnit,
        recipeCholine,
        recipeCholineUnit,
        recipeFiber,
        recipeFiberUnit,
        recipeFolicAcid,
        recipeFolicAcidUnit,
        recipeIodine,
        recipeIodineUnit,
        recipeIron,
        recipeIronUnit,
        recipeMagnesium,
        recipeMagnesiumUnit,
        recipePotassium,
        recipePotassiumUnit,
        recipeSaturatedFat,
        recipeSaturatedFatUnit,
     */

    //Additionals:

    const [recipeCholesterol, setRecipeCholesterol] = useState(0);
    const [recipeCholesterolUnit, setRecipeCholesterolUnit] = useState('mg');
    const [recipeCholine, setRecipeCholine] = useState(0);
    const [recipeCholineUnit, setRecipeCholineUnit] = useState('mg');
    const [recipeFiber, setRecipeFiber] = useState(0);
    const [recipeFiberUnit, setRecipeFiberUnit] = useState('mg');
    const [recipeFolicAcid, setRecipeFolicAcid] = useState(0);
    const [recipeFolicAcidUnit, setRecipeFolicAcidUnit] = useState('mg');
    const [recipeIodine, setRecipeIodine] = useState(0);
    const [recipeIodineUnit, setRecipeIodineUnit] = useState('mg');
    const [recipeIron, setRecipeIron] = useState(0);
    const [recipeIronUnit, setRecipeIronUnit] = useState('mg');
    const [recipeMagnesium, setRecipeMagnesium] = useState(0);
    const [recipeMagnesiumUnit, setRecipeMagnesiumUnit] = useState('mg');
    const [recipePotassium, setRecipePotassium] = useState(0);
    const [recipePotassiumUnit, setRecipePotassiumUnit] = useState('mg');
    const [recipeSaturatedFat, setRecipeSaturatedFat] = useState(0);
    const [recipeSaturatedFatUnit, setRecipeSaturatedFatUnit] = useState('mg');

    const vitaminUnits = [
        {
            id: 1,
            title: 'mg',
            value: 'mg'
        },
        {
            id: 2,
            title: 'g',
            value: 'g'
        },
        {
            id: 3,
            title: 'mcg',
            value: 'mcg'
        },
        {
            id: 4,
            title: 'μg',
            value: 'μg'
        },
        {
            id: 5,
            title: 'IU',
            value: 'IU'
        }
    ];

    const fetchAllRecipes = async () => {
        await axios.get(
            ENDPOINTS.LIST_ALL_RECIPES,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                }
            }
        ).then((response) => {
            console.log("ALL_RECIPES_RESPONSE:", response.data);
            let reversedData = response.data.data.reverse();
            const sortedDataWithisDeleted = reversedData.sort((a: any, b: any) => {
                if (a.isDeleted && !b.isDeleted) {
                    return 1; // a is deleted, b is not
                } else if (!a.isDeleted && b.isDeleted) {
                    return -1; // b is deleted, a is not
                } else {
                    return 0; // both are either deleted or not
                }
            }
            );
            dispatch(setAllRecipes(sortedDataWithisDeleted));
            dispatch(setRecipesLoading(false));
        }).catch((error) => {
            console.log("ALL_RECIPES_ERROR:", error);
        });
    };

    const searchRecipes = async (searchQuery: string) => {
        dispatch(setRecipesLoading(true));
        await axios.get(
            ENDPOINTS.SEARCH_RECIPES,
            {
                params: {
                    searchQuery: searchQuery,
                },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                }
            }
        ).then((response) => {
            console.log("SEARCH_RECIPES_RESPONSE:", response.data);
            let reversedData = response.data.data.reverse();
            const sortedDataWithisDeleted = reversedData.sort((a: any, b: any) => {
                if (a.isDeleted && !b.isDeleted) {
                    return 1; // a is deleted, b is not
                } else if (!a.isDeleted && b.isDeleted) {
                    return -1; // b is deleted, a is not
                } else {
                    return 0; // both are either deleted or not
                }
            }
            );
            dispatch(setAllRecipes(sortedDataWithisDeleted));
            dispatch(setRecipesLoading(false));
        }).catch((error) => {
            console.log("SEARCH_RECIPES_ERROR:", error);
            dispatch(setRecipesLoading(false));
        });
    };

    const filterRecipes = async (filters: {
        recipeType?: string;
        recipeTrimester?: string;
        recipeTags?: string[];
        isPremium?: boolean;
        isPriority?: boolean;
        isDeleted?: boolean;
    }) => {
        dispatch(setRecipesLoading(true));
        
        // Backend'e göndermeden önce sadece dolu değerleri içeren bir obje oluştur
        const cleanedFilters: any = {};
        
        if (filters.recipeType && filters.recipeType.trim() !== '') {
            cleanedFilters.recipeType = filters.recipeType;
        }
        if (filters.recipeTrimester && filters.recipeTrimester.trim() !== '') {
            cleanedFilters.recipeTrimester = filters.recipeTrimester;
        }
        if (filters.recipeTags && filters.recipeTags.length > 0) {
            cleanedFilters.recipeTags = filters.recipeTags;
        }
        if (filters.isPremium !== undefined && filters.isPremium !== null) {
            cleanedFilters.isPremium = filters.isPremium;
        }
        if (filters.isPriority !== undefined && filters.isPriority !== null) {
            cleanedFilters.isPriority = filters.isPriority;
        }
        if (filters.isDeleted !== undefined && filters.isDeleted !== null) {
            cleanedFilters.isDeleted = filters.isDeleted;
        }
        
        console.log("CLEANED_FILTERS:", cleanedFilters);
        
        await axios.post(
            ENDPOINTS.FILTER_RECIPES,
            cleanedFilters,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                }
            }
        ).then((response) => {
            console.log("FILTER_RECIPES_RESPONSE:", response.data);
            let reversedData = response.data.data.reverse();
            const sortedDataWithisDeleted = reversedData.sort((a: any, b: any) => {
                if (a.isDeleted && !b.isDeleted) {
                    return 1; // a is deleted, b is not
                } else if (!a.isDeleted && b.isDeleted) {
                    return -1; // b is deleted, a is not
                } else {
                    return 0; // both are either deleted or not
                }
            }
            );
            dispatch(setAllRecipes(sortedDataWithisDeleted));
            dispatch(setRecipesLoading(false));
        }).catch((error) => {
            console.log("FILTER_RECIPES_ERROR:", error);
            dispatch(setRecipesLoading(false));
        });
    };

    const deleteRecipe = async (recipeId: string) => {
        dispatch(setRecipesLoading(true));
        await axios.delete(
            BASE_URL + '/api/recipes/deleteRecipe?recipeId=' + recipeId,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                }
            }
        ).then((response) => {
            console.log("DELETE_RECIPE_RESPONSE:", response.data);
            toast.success('Recipe Deleted Successfully');
            dispatch(setRecipesLoading(false));
            dispatch(setSelectedRecipePage(1));
        }).catch((error) => {
            console.log("DELETE_RECIPE_ERROR:", error);
            toast.error('Error Deleting Recipe');
            dispatch(setRecipesLoading(false));
        });
    };

    const addNewRecipe = async () => {
        dispatch(setRecipesLoading(true));
        let ingredientList: any = [];
        for (let i = 0; i < recipeIngredients.length; i++) {
            //catch if there is last char is comma
            if (recipeIngredients[i].charAt(recipeIngredients[i].length - 1) === ',') {
                const changedValue = recipeIngredients[i].slice(0, -1);
                ingredientList.push(changedValue);
            } else {
                ingredientList.push(recipeIngredients[i]);
            }
        }
        const recipeData = {
            recipeName: recipeName,
            recipeType: recipeType,
            recipeTrimester: recipeTrimester,
            recipePreparationTime: Number(recipePreparationTime),
            recipeCookTime: Number(recipeCookTime),
            recipeServes: Number(recipeServes),
            recipeTags: recipeTags,
            recipeMethod: recipeMethod,
            recipeIngredients: ingredientList,
            recipeImage: recipeImage,
            recipeCarbs: Number(recipeCarbs),
            recipeProtein: Number(recipeProtein),
            recipeFats: Number(recipeFats),
            recipeCalories: Number(recipeCalories),
            recipeCalcium: Number(recipeCalcium),
            recipeVitaminA: Number(recipeVitaminA),
            recipeVitaminAUnit: recipeVitaminAUnit,
            recipeVitaminB6: Number(recipeVitaminB6),
            recipeVitaminB6Unit: recipeVitaminB6Unit,
            recipeVitaminB12: Number(recipeVitaminB12),
            recipeVitaminB12Unit: recipeVitaminB12Unit,
            recipeVitaminC: Number(recipeVitaminC),
            recipeVitaminCUnit: recipeVitaminCUnit,
            recipeVitaminD: Number(recipeVitaminD),
            recipeVitaminDUnit: recipeVitaminDUnit,
            recipeVitaminE: Number(recipeVitaminE),
            recipeVitaminEUnit: recipeVitaminEUnit,
            recipeVitaminK: Number(recipeVitaminK),
            recipeVitaminKUnit: recipeVitaminKUnit,
            recipeCholesterol: Number(recipeCholesterol),
            recipeCholesterolUnit: recipeCholesterolUnit,
            recipeCholine: Number(recipeCholine),
            recipeCholineUnit: recipeCholineUnit,
            recipeFiber: Number(recipeFiber),
            recipeFiberUnit: recipeFiberUnit,
            recipeFolicAcid: Number(recipeFolicAcid),
            recipeFolicAcidUnit: recipeFolicAcidUnit,
            recipeIodine: Number(recipeIodine),
            recipeIodineUnit: recipeIodineUnit,
            recipeIron: Number(recipeIron),
            recipeIronUnit: recipeIronUnit,
            recipeMagnesium: Number(recipeMagnesium),
            recipeMagnesiumUnit: recipeMagnesiumUnit,
            recipePotassium: Number(recipePotassium),
            recipePotassiumUnit: recipePotassiumUnit,
            recipeSaturatedFat: Number(recipeSaturatedFat),
            recipeSaturatedFatUnit: recipeSaturatedFatUnit,
            blogReferences: blogReferences,
            isPremium: isPremium,
        };
        console.log("RECIPE_DATA:", recipeData);
        await axios.post(
            BASE_URL + '/api/recipes/addNewRecipe',
            recipeData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                }
            }
        ).then((response) => {
            console.log("ADD_RECIPE_RESPONSE:", response.data);
            toast.success('Recipe Added Successfully');
            dispatch(setRecipesLoading(false));
            dispatch(setSelectedRecipePage(1));
        }).catch((error) => {
            console.log("ADD_RECIPE_ERROR:", error);
            if (error.response.data.msg === 'Please fill all the required fields!') {
                toast.error('Missing Fields:' + JSON.stringify(error.response.data.field));
            }
            dispatch(setRecipesLoading(false));
        });
        dispatch(setRecipesLoading(false));

    };

    const returnSelectedRecipePage = () => {
        switch (selectedRecipePage) {
            case 1:
                return <ListRecipes />;
            case 2:
                return <AddNewRecipe />;
            case 3:
                return <UpdateRecipesPage />;
            case 4:
                return <DeleteRecipe />;
            default:
                return <ListRecipes />;
        }
    };

    const handleUpdate = async () => {
        if (
            selectedRecipeData._id === '' ||
            selectedRecipeData.recipeName === '' ||
            selectedRecipeData.recipeType === '' ||
            selectedRecipeData.recipeTrimester === '' ||
            selectedRecipeData.recipeImage === ''
        )
            return toast.error('Please fill all the required fields!');

        dispatch(setRecipesLoading(true));
        await axios.put(
            BASE_URL + '/api/recipes/updateRecipev2',
            {
                recipeId: selectedRecipeData._id,
                recipeName: selectedRecipeData.recipeName,
                recipeType: selectedRecipeData.recipeType,
                recipeTrimester: selectedRecipeData.recipeTrimester,
                recipePreparationTime: selectedRecipeData.recipePreparationTime,
                recipeCookTime: selectedRecipeData.recipeCookTime,
                recipeServes: selectedRecipeData.recipeServes,
                recipeTags: selectedRecipeData.recipeTags,
                recipeMethod: selectedRecipeData.recipeMethod,
                recipeIngredients: selectedRecipeData.recipeIngredients,
                recipeImage: selectedRecipeData.recipeImage,
                recipeCarbs: selectedRecipeData.recipeCarbs,
                recipeProtein: selectedRecipeData.recipeProtein,
                recipeFats: selectedRecipeData.recipeFats,
                recipeCalories: selectedRecipeData.recipeCalories,
                recipeCalcium: selectedRecipeData.recipeCalcium,
                recipeVitaminA: selectedRecipeData.recipeVitaminA,
                recipeVitaminAUnit: selectedRecipeData.recipeVitaminAUnit,
                recipeVitaminB12: selectedRecipeData.recipeVitaminB12,
                recipeVitaminB12Unit: selectedRecipeData.recipeVitaminB12Unit,
                recipeVitaminB6: selectedRecipeData.recipeVitaminB6,
                recipeVitaminB6Unit: selectedRecipeData.recipeVitaminB6Unit,
                recipeVitaminC: selectedRecipeData.recipeVitaminC,
                recipeVitaminCUnit: selectedRecipeData.recipeVitaminCUnit,
                recipeVitaminD: selectedRecipeData.recipeVitaminD,
                recipeVitaminDUnit: selectedRecipeData.recipeVitaminDUnit,
                recipeVitaminE: selectedRecipeData.recipeVitaminE,
                recipeVitaminEUnit: selectedRecipeData.recipeVitaminEUnit,
                recipeVitaminK: selectedRecipeData.recipeVitaminK,
                recipeVitaminKUnit: selectedRecipeData.recipeVitaminKUnit,
                recipeCholesterol: selectedRecipeData.recipeCholesterol,
                recipeCholesterolUnit: selectedRecipeData.recipeCholesterolUnit,
                recipeCholine: selectedRecipeData.recipeCholine,
                recipeCholineUnit: selectedRecipeData.recipeCholineUnit,
                recipeFiber: selectedRecipeData.recipeFiber,
                recipeFiberUnit: selectedRecipeData.recipeFiberUnit,
                recipeFolicAcid: selectedRecipeData.recipeFolicAcid,
                recipeFolicAcidUnit: selectedRecipeData.recipeFolicAcidUnit,
                recipeIodine: selectedRecipeData.recipeIodine,
                recipeIodineUnit: selectedRecipeData.recipeIodineUnit,
                recipeIron: selectedRecipeData.recipeIron,
                recipeIronUnit: selectedRecipeData.recipeIronUnit,
                recipeMagnesium: selectedRecipeData.recipeMagnesium,
                recipeMagnesiumUnit: selectedRecipeData.recipeMagnesiumUnit,
                recipePotassium: selectedRecipeData.recipePotassium,
                recipePotassiumUnit: selectedRecipeData.recipePotassiumUnit,
                recipeSaturatedFat: selectedRecipeData.recipeSaturatedFat,
                recipeSaturatedFatUnit: selectedRecipeData.recipeSaturatedFatUnit,
                blogReferences: selectedRecipeData.blogReferences,
                isPremium: selectedRecipeData.isPremium,
                isPriority: selectedRecipeData.isPriority,
                isDeleted: selectedRecipeData.isDeleted,
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                }
            }
        ).then((response) => {
            console.log("UPDATE_RECIPE_RESPONSE:", response.data);
            toast.success('Recipe Updated Successfully');
            dispatch(setRecipesLoading(false));
            dispatch(setSelectedRecipePage(1));
        }).catch((error) => {
            console.log("UPDATE_RECIPE_ERROR:", error);
            if (error.response.data.msg === 'Please fill all the required fields!') {
                toast.error('Missing Fields:' + JSON.stringify(error.response.data.field));
            }
            dispatch(setRecipesLoading(false));
        });
    };

    const [file, setFile] = useState<any>(null);  // Fotoğraf dosyası
    const [uploading, setUploading] = useState<boolean>(false); // Yükleme durumu
    const [progress, setProgress] = useState<number>(0); // Yükleme ilerlemesi

    // Update için ayrı image upload state'leri
    const [updateUploading, setUpdateUploading] = useState<boolean>(false);
    const [updateProgress, setUpdateProgress] = useState<number>(0);

    const handleFileChange = async (event: any) => {
        toast.loading("Image loading...");
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            console.log("Selected File =>", selectedFile);
            await handleUpload(selectedFile);

        }
    };

    const handleUpload = async (file_: any) => {
        console.log("File =>", file_);
        if (!file_) return;

        const storageRef = ref(storage, 'recipes/' + file_.name);
        const uploadTask = uploadBytesResumable(storageRef, file_);

        // Yükleme durumu takibi
        setUploading(true);
        uploadTask.on(
            'state_changed',
            (snapshot) => {
                // Yükleme ilerlemesi (isteğe bağlı)
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Upload is ${progress}% done`);
                setProgress(progress);
            },
            (error) => {
                console.error('Upload error:', error);
                setUploading(false);
            },
            () => {
                // Yükleme tamamlandığında URL'yi al
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    console.log('File available at', downloadURL);
                    setUploading(false);
                    setRecipeImage(downloadURL);
                    setTimeout(() => { toast.dismiss() }, 1000);
                    toast.success("Image loaded successfully");
                });
            }
        );

    };

    // Update için image upload fonksiyonu
    const handleUpdateFileChange = async (event: any) => {
        toast.loading("Image updating...");
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            console.log("Selected File for Update =>", selectedFile);
            await handleUpdateUpload(selectedFile);
        }
    };

    const handleUpdateUpload = async (file_: any) => {
        console.log("Update File =>", file_);
        if (!file_) return;

        const storageRef = ref(storage, 'recipes/' + file_.name);
        const uploadTask = uploadBytesResumable(storageRef, file_);

        // Yükleme durumu takibi
        setUpdateUploading(true);
        uploadTask.on(
            'state_changed',
            (snapshot) => {
                // Yükleme ilerlemesi
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Update Upload is ${progress}% done`);
                setUpdateProgress(progress);
            },
            (error) => {
                console.error('Update Upload error:', error);
                setUpdateUploading(false);
                toast.error('Image update failed');
            },
            () => {
                // Yükleme tamamlandığında URL'yi al ve Redux'a kaydet
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    console.log('Updated image available at', downloadURL);
                    setUpdateUploading(false);

                    // Redux store'daki selectedRecipeData'yı güncelle
                    dispatch(updateSelectedRecipeData({ key: "recipeImage", value: downloadURL }));

                    setTimeout(() => { toast.dismiss() }, 1000);
                    toast.success("Image updated successfully");
                });
            }
        );
    };

    return {
        selectedRecipePage,
        fetchAllRecipes,
        searchRecipes,
        filterRecipes,
        changeSelectedRecipePage,
        returnSelectedRecipePage,
        selectableRecipeTags,
        recipeTypes,
        recipeTrimesters,
        recipeName,
        setRecipeName,
        recipeType,
        setRecipeType,
        recipeTrimester,
        setRecipeTrimester,
        recipePreparationTime,
        setRecipePreparationTime,
        recipeCookTime,
        setRecipeCookTime,
        recipeServes,
        setRecipeServes,
        recipeTags,
        setRecipeTags,
        recipeMethod,
        setRecipeMethod,
        recipeIngredients,
        setRecipeIngredients,
        recipeImage,
        setRecipeImage,
        recipeCarbs,
        setRecipeCarbs,
        recipeProtein,
        setRecipeProtein,
        recipeFats,
        setRecipeFats,
        recipeCalories,
        setRecipeCalories,
        recipeCalcium,
        setRecipeCalcium,
        recipeVitaminA,
        recipeVitaminAUnit,
        recipeVitaminB6,
        recipeVitaminB6Unit,
        recipeVitaminB12,
        recipeVitaminB12Unit,
        recipeVitaminC,
        recipeVitaminCUnit,
        recipeVitaminD,
        recipeVitaminDUnit,
        recipeVitaminE,
        recipeVitaminEUnit,
        recipeVitaminK,
        recipeVitaminKUnit,
        setRecipeVitaminA,
        setRecipeVitaminAUnit,
        setRecipeVitaminB6,
        setRecipeVitaminB6Unit,
        setRecipeVitaminB12,
        setRecipeVitaminB12Unit,
        setRecipeVitaminC,
        setRecipeVitaminCUnit,
        setRecipeVitaminD,
        setRecipeVitaminDUnit,
        setRecipeVitaminE,
        setRecipeVitaminEUnit,
        setRecipeVitaminK,
        setRecipeVitaminKUnit,
        recipeCholesterol,
        recipeCholesterolUnit,
        recipeCholine,
        recipeCholineUnit,
        recipeFiber,
        recipeFiberUnit,
        recipeFolicAcid,
        recipeFolicAcidUnit,
        recipeIodine,
        recipeIodineUnit,
        recipeIron,
        recipeIronUnit,
        recipeMagnesium,
        recipeMagnesiumUnit,
        recipePotassium,
        recipePotassiumUnit,
        recipeSaturatedFat,
        recipeSaturatedFatUnit,
        setRecipeCholesterol,
        setRecipeCholesterolUnit,
        setRecipeCholine,
        setRecipeCholineUnit,
        setRecipeFiber,
        setRecipeFiberUnit,
        setRecipeFolicAcid,
        setRecipeFolicAcidUnit,
        setRecipeIodine,
        setRecipeIodineUnit,
        setRecipeIron,
        setRecipeIronUnit,
        setRecipeMagnesium,
        setRecipeMagnesiumUnit,
        setRecipePotassium,
        setRecipePotassiumUnit,
        setRecipeSaturatedFat,
        setRecipeSaturatedFatUnit,
        blogReferences,
        setBlogReferences,
        isPremium,
        setIsPremium,
        addNewRecipe,
        handleFileChange,
        uploading,
        progress,
        deleteRecipe,
        vitaminUnits,
        handleUpdate,
        handleUpdateFileChange,
        updateUploading,
        updateProgress,
    };
};